import serverConnection from '../common/server-connection.js';

export default function() {
  var shops = new Vue({
    el: 'main',
    data: {
      floorFilter: [],
      categoryFilter: [],
      search: ""
    },
    created: function () {
      var that = this;
      $('.floor-filter-container input:checked').each(function(){
        that.floorFilter.push($(this).data('floor-id'));
      });

      $('.category-filter-container input:checked').each(function(){
        that.categoryFilter.push($(this).data('category-id'));
      });
    },
    methods: {
      updateFilter: function(){
        var that = this;
        that.floorFilter = [];
        that.categoryFilter = [];
        $('.floor-filter-container input:checked').each(function(){
          that.floorFilter.push($(this).data('floor-id'));
        });

        $('.category-filter-container input.category:checked').each(function(){
          that.categoryFilter.push($(this).data('category-id'));
        });

        if( $('.category-filter-container input.category:checked').length == $('.category-filter-container input.category').length ){
          $('#checkbox_cat_all').prop('checked', true);
        } else {
          $('#checkbox_cat_all').prop('checked', false);
        }
      },
      isInFilter: function(floor, cats){
        cats = cats + "";
        for(var i=0; i < this.floorFilter.length; i++){
          if( $.inArray( (floor*1), this.floorFilter) >= 0 ){
            for(var v=0; v < this.categoryFilter.length; v++){
              var catsArray = cats.split(',');
              for(var c=0; c<catsArray.length; c++){
                if( $.inArray( (catsArray[c]*1), this.categoryFilter) >= 0 ){
                  return true;
                }
              }
            }
          }
        }
        return false;
      },
      isInSearch: function(Name, id){
        if(this.search==""){
          return true
        } else {
          return (Name.toUpperCase().indexOf(this.search.toUpperCase()) >=0 || id.toUpperCase().indexOf(this.search.toUpperCase()) >=0);
        }
      },
      updateFilterAll: function(e){
        var that = this;
        if($('#checkbox_cat_all').is(':checked')){
          $('.category-filter-container input.category').prop('checked', true);
        } else {
          $('.category-filter-container input.category').prop('checked', false);
        }
        that.updateFilter();
      }
    }
  });
}


// WEBPACK FOOTER //
// app/javascript/src/javascripts/page/shops.js